import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';
import { ScrollService } from '../scroll/scroll.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  // Variáveis para controlar o estado do loading
  private loadingActive: boolean;
  private loadingActive$: BehaviorSubject<boolean>;

  // Variáveis para controle da lista de eventos de loading
  private requests$ = new BehaviorSubject<string[]>([]);
  private requestCounts = new Map<string, number>();
  private spinnerVisible = false;

  constructor(private spinner: NgxSpinnerService, private scrollService: ScrollService) {
    this.loadingActive = false;
    this.loadingActive$ = new BehaviorSubject(this.loadingActive);
    this.eventoLoading();
  }

  public getLoadingStatus(): Observable<boolean> {
    return this.loadingActive$;
  }

  public isLoadingActive() {
    return this.loadingActive;
  }

  // Adciona um evento de loading que consequentemente bloqueará a tela
  public adicionaLoadingEvent(requestUrl: string) {
    this.requestCounts.set(requestUrl, (this.requestCounts.get(requestUrl) || 0) + 1);
    this.requests$.next(Array.from(this.requestCounts.keys()));
  }

  // Remove um evento de loading
  // Caso a lista de eventos de loading fique vazia a tela será desbloqueada
  public removeLoadingEvent(requestUrl: string) {
    const requestCount = this.requestCounts.get(requestUrl);

    if (requestCount !== undefined) {
      if (requestCount === 1) {
        this.requestCounts.delete(requestUrl);
      } else {
        this.requestCounts.set(requestUrl, requestCount - 1);
      }
      this.requests$.next(Array.from(this.requestCounts.keys()));
    }
  }

  public showInitialBloq() {
    this.loadingActive = true;
    this.loadingActive$.next(this.loadingActive);
  }

  // Função que inicia bloqueio da tela
  private show() {
    if (this.spinnerVisible) {
      return;
    }

    this.spinnerVisible = true;
    this.loadingActive = true;
    this.loadingActive$.next(this.loadingActive);
    this.scrollService.focusToElement('.fd-spinner .overlay');
    this.spinner.show();
  }

  // Função que finaliza o bloqueio da tela
  public hide() {
    if (this.requestCounts.size > 0 || (!this.spinnerVisible && !this.loadingActive)) {
      return;
    }

    this.spinnerVisible = false;
    this.loadingActive = false;
    this.loadingActive$.next(this.loadingActive);
    this.spinner.hide();
  }

  // Função que observa as alterações da lista de eventos para controlar o bloqueio da tela
  private eventoLoading() {
    this.requests$.asObservable().subscribe((requests) => {
      if (requests.length) {
        this.show();
      } else {
        this.hide();
      }
    });
  }
}
